module.exports = __webpack_public_path__ + "img/conduite.13edb55b.png";